import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const InfoRow = ({ icon: Icon, label, isRTL, children }) => (
  <div className={`flex items-start gap-4 ${isRTL ? 'flex-row-reverse text-right' : ''}`}>
    <div className="w-10 h-10 bg-[#9B4B8C]/10 rounded-lg flex items-center justify-center flex-shrink-0">
      <Icon className="w-5 h-5 text-[#9B4B8C]" />
    </div>
    <div>
      <p className="font-medium text-gray-900">{label}</p>
      {children}
    </div>
  </div>
);

const ContactInfo = ({ t, isRTL, headquarters }) => (
  <>
    <h2 className="text-2xl font-bold text-gray-900 mb-6">{t.contact.info.title}</h2>
    <div className="bg-gray-50 rounded-2xl p-8">
      <h3 className="text-lg font-bold text-gray-900 mb-6">{t.contact.info.headquarters}</h3>
      <div className="space-y-4">
        <InfoRow icon={MapPin} label={t.contact.info.address} isRTL={isRTL}>
          <p className="text-gray-600">
            {headquarters.address}<br />
            {headquarters.addressLine2}<br />
            {headquarters.city}
          </p>
        </InfoRow>

        <InfoRow icon={Phone} label={t.contact.info.phone} isRTL={isRTL}>
          <a href={`tel:${headquarters.phone}`} className="text-[#9B4B8C] hover:underline">
            {headquarters.phone}
          </a>
        </InfoRow>

        <InfoRow icon={Mail} label={t.contact.info.email} isRTL={isRTL}>
          <a href={`mailto:${headquarters.email}`} className="text-[#9B4B8C] hover:underline block">
            {headquarters.email}
          </a>
          <a href={`mailto:${headquarters.email2}`} className="text-[#9B4B8C] hover:underline block">
            {headquarters.email2}
          </a>
        </InfoRow>

        <InfoRow icon={Clock} label={t.contact.info.hours} isRTL={isRTL}>
          <p className="text-gray-600">{t.contact.info.hoursValue}</p>
        </InfoRow>
      </div>
    </div>
  </>
);

export default ContactInfo;
